import type {Limit} from "crqlar-react-common/dist/models/common/limit";

/** What every survey list asked for before lists paged, so the first request stays the same. */
export const LIST_PAGE_SIZE = 200;

/** The part of a page the loop reads; `Page` and `AggregationPage` both fit. */
export interface ListPage<T> {
    content?: T[];
    totalElements?: number;
}

/**
 * Every row of a list endpoint. A picker fed only the first page silently loses what lies past it, and a target set
 * saved from that picker drops those surveys. Fetches pages while the rows are fewer than `totalElements` and stops
 * on an empty page - the same loop as the server table's `collectAllRows`.
 */
export async function fetchEveryPage<T>(
    fetchPage: (limit: Limit) => Promise<ListPage<T>>,
    pageSize = LIST_PAGE_SIZE
): Promise<T[]> {
    const rows: T[] = [];

    for (let pageIndex = 0; ; pageIndex++) {
        const page = await fetchPage({offset: pageIndex * pageSize, limit: pageSize});
        // Taken before this page's rows are added, so a page without a total ends the list, as in the server table.
        const total = page.totalElements ?? rows.length;
        rows.push(...(page.content ?? []));

        if (!page.content?.length || rows.length >= total) return rows;
    }
}
